import { styled, Stack } from '../../../base';

export const StyledTimeToHireWrapper = styled(Stack)({
    flex: 1,
    height: '100%',
});
